export const getDropzoneAccept = (accept) => {
  if (!accept || !Array.isArray(accept)) return {};
  const mimeMap = {
    ".png": "image/png",
    ".jpg": "image/jpeg",
    ".jpeg": "image/jpeg",
    ".webp": "image/webp",
    ".pdf": "application/pdf",
    ".svg": "image/svg+xml",
    ".gif": "image/gif",
    ".mp4": "video/mp4",
    ".mov": "video/quicktime",
    ".webm": "video/webm",
  };

  const result = {};
  accept.forEach((ext) => {
    const extLower = ext.toLowerCase();
    const mimeType = mimeMap[extLower] || `application/${extLower.replace(".", "")}`;
    if (!result[mimeType]) {
      result[mimeType] = [];
    }
    if (!result[mimeType].includes(extLower)) {
      result[mimeType].push(extLower);
    }
  });
  return result;
};
